import styled from '@emotion/styled';
import * as React from 'react';

import { StatusPageAlert } from 'components/statusPage/StatusPageAlert';
import { Incident } from 'components/statusPage/types';
import { BlockWrapper } from 'utils/notice.styles';

const Wrapper = styled(BlockWrapper)`
  margin-bottom: var(--spacing-l4);
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l2);
`;

export function StatusPageIssues({
  incidents
}: {
  incidents: Incident[];
}): JSX.Element | null {
  if (!incidents.length) {
    return null;
  }

  return (
    <Wrapper>
      {incidents.map((incident: Incident) => (
        <StatusPageAlert key={incident.id} incident={incident} />
      ))}
    </Wrapper>
  );
}
